import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Inject Facebook domain verification meta tag
const meta = document.createElement('meta');
meta.name = 'facebook-domain-verification';
meta.content = 'hb936dl8rvti29zdk6ib2cazlr9v4u';
document.head.appendChild(meta);
(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', '892577757067744');
(window as any).fbq('track', 'PageView');
// Inject Meta Pixel noscript fallback
const noscript = document.createElement('noscript');
const img = document.createElement('img');
img.height = 1;
img.width = 1;
img.style.display = 'none';
img.src = 'https://www.facebook.com/tr?id=892577757067744&ev=PageView&noscript=1';
noscript.appendChild(img);
document.body.appendChild(noscript);
render(<App data-id="element-174" />, document.getElementById('root'));